import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Globals } from 'src/app/common/globals';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/common/services/common.service';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private globals: Globals,
    private commonService: CommonService
  ) { }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {

    const url = request.url.split('/');
    const uploadEndpointsSecondLast = ['add_health_sciences_documents', 'add_transcripts_documents', 'add_licenses_documents', 'add-ceu-activity'];
    const uploadEndpointsLast = ['add_fitness_response', 'import-voucher-file', 'exam-score-excel'];
    const add_documents = uploadEndpointsSecondLast.includes(url[url.length - 2]) || uploadEndpointsLast.includes(url[url.length - 1]);
    const hideResMsg = url[url.length - 1] === 'browser-logs';

    const header: any = {
      Authorization: `${this.commonService.getCookie('token_type') +
        ' ' +
        this.commonService.getCookie('access_token')
        }`,
      Accept: request.method === 'POST' && add_documents ? 'multipart/form-data' : 'application/json',
    };
    if (this.globals.impersonateId) {
      header.Impersonateid = `${this.globals.impersonateId}`;
    }

    request = request.clone({
      setHeaders: header,
    });

    return next.handle(request).pipe(
      tap({
        next: (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            if (event.body.error_code === 2008) {
              return false;
            } else {
              if (event.body.message_code) {
                this.commonService.showCommonSuccessNotification(
                  event.body.message
                );
              }
              return next.handle(request);
            }
          } else {
            return false;
          }
        },
        error: (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (hideResMsg) {
              return false;
            } else {

              if (err.status === 0) {
                this.commonService.hideLoader();
                // this.commonService.showCommonErrorNotification(
                //   'Network not connected. Please check your internet connection and try again.'
                // );
                this.commonService.showCommonErrorNotification();
                return false;
              }

              if (err.status === 403 && err.error.message === 'Session expired') {
                this.commonService.hideLoader();
                this.commonService.showCommonErrorNotification(
                  'Your session has expired. Please log in again to continue using the app.'
                );
                this.globals.authData = null;
                this.globals.isLoggedIn = false;
                this.commonService.clearLoginCookie();
                this.router.navigate(['/']);
                return false;
              } else if (err.status === 403 && err.error.message == 'You are not authorized to access this resource.') {
                this.commonService.hideLoader();
                this.commonService.showCommonErrorNotification(
                  'You are not authorized to access this resource.'
                );
                this.router.navigate(['/']);
                return false;
              } else if (err.status === 401 && err.error.message === 'Unauthorized') {
                this.commonService.hideLoader();
                this.commonService.showCommonErrorNotification(
                  'Your session has expired. Please log in again to continue using the app.'
                );
                this.globals.authData = null;
                this.globals.isLoggedIn = false;
                this.commonService.clearLoginCookie();
                this.router.navigate(['/']);
                return false;
              } else if (err.status === 429 && err.error.message === 'Too Many Attempts.') {
                this.commonService.hideLoader();
                this.commonService.showCommonErrorNotification(
                  'You have made too many requests. Please try again later.'
                );
                return false;
              } else if (err.status === 406 && err.error.message === 'Not Verify') {
                this.commonService.hideLoader();
                return false;
              } else if (err.error.message_code) {
                this.commonService.hideLoader();
                this.commonService.showCommonErrorNotification(
                  err.error.message
                );
                return false;
              } else {
                this.commonService.hideLoader();
                this.commonService.showCommonErrorNotification();
                return false;
              }
            }
          } else {
            return false;
          }
        }
      })
    );
  }
}
